import styled from 'styled-components'

export const IconContainer = styled.button`
  width: 25px;
  height: 25px;
  align-self: flex-end;
  cursor: pointer;
  background-color: transparent;
  padding: 0;
  border: none;
`
